import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-14 text-center px-4 text-gray-500 text-lg space-y-4"
}
const _hoisted_2 = {
  key: 1,
  class: "space-y-8"
}
const _hoisted_3 = { class: "flex items-center gap-2" }

import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import MainViewCard from '@/components/common/MainViewCard.vue';
import RecordsWeeklyChart from '@/components/charts/RecordsWeeklyChart.vue';
import RecordsTable from '@/components/records/RecordsTable.vue';
import BulkCreateButton from '@/components/records/BulkCreateButton.vue';
import { Button } from '@/components/ui/button';
import { ColumnVisibilityMenu } from '@/components/ui/data-table';
import colors from '@/plugins/tailwind';
import { BULK_CREATE, useTransfersPage } from './useTransfersPage';

/*
 * This page holds its own data rather than delegating it to a single child, which is the exception
 * here. The chart and the table read the same fetch, one way: the chart bins every loaded row and
 * stays that way, the table shows the subset the picked week and the header facets leave, and the
 * totals cover that same subset. Whichever child owned the fetch, the other would have to reach
 * across to it. All of the logic lives in the shared records composables beside the page. The
 * column-visibility control rides in `RecordsTable`'s own `#actions` slot, beside its heading, the
 * same way Slaughters'/Status's does.
 *
 * A move whose destination is also in the current selection appears on the Insertions page too,
 * from the receiving end. The two pages anchor on opposite ends of the same registration pair, so
 * that is the intended reading, not a duplicate.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const {
    bins,
    columnFilters,
    columns,
    columnToggleOptions,
    facetOptions,
    isError,
    isFetching,
    refetch,
    refreshAfterFormActivity,
    resetSelection,
    selectWeek,
    selectedWeekStart,
    setAllColumns,
    sorting,
    subtitle,
    toggleColumn,
    totals,
    visibleRows,
} = useTransfersPage();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardContentLayout, {
    class: "space-y-8",
    heading: _ctx.$t('views.pigs.transfers.header.heading'),
    "has-period-picker": true,
    "has-pig-type-picker": true
  }, {
    default: _withCtx(() => [
      (_unref(isError))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.pigs.records.errors.couldNotLoadData')), 1),
            _createVNode(_unref(Button), {
              variant: "outline",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(refetch)()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('views.pigs.records.errors.retry')), 1)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(MainViewCard, { class: "py-4 px-2" }, {
              default: _withCtx(() => [
                _createVNode(RecordsWeeklyChart, {
                  bins: _unref(bins),
                  "selected-week-start": _unref(selectedWeekStart),
                  color: _unref(colors).chart.transfer,
                  title: _ctx.$t('views.pigs.transfers.chart.heading'),
                  onWeekSelected: _unref(selectWeek),
                  onSelectionReset: _unref(resetSelection)
                }, null, 8, ["bins", "selected-week-start", "color", "title", "onWeekSelected", "onSelectionReset"])
              ]),
              _: 1
            }),
            _createVNode(MainViewCard, { class: "overflow-hidden" }, {
              default: _withCtx(() => [
                _createVNode(RecordsTable, {
                  sorting: _unref(sorting),
                  "onUpdate:sorting": _cache[3] || (_cache[3] = ($event: any) => (_isRef(sorting) ? (sorting).value = $event : null)),
                  "column-filters": _unref(columnFilters),
                  "onUpdate:columnFilters": _cache[4] || (_cache[4] = ($event: any) => (_isRef(columnFilters) ? (columnFilters).value = $event : null)),
                  columns: _unref(columns),
                  rows: _unref(visibleRows),
                  totals: _unref(totals),
                  "facet-options": _unref(facetOptions),
                  loading: _unref(isFetching),
                  heading: _ctx.$t('views.pigs.transfers.table.heading'),
                  subtitle: _unref(subtitle),
                  onFormActivity: _unref(refreshAfterFormActivity)
                }, {
                  actions: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(BulkCreateButton, {
                        "form-id": _unref(BULK_CREATE).formId,
                        label: _ctx.$t(_unref(BULK_CREATE).labelKey),
                        "location-step": _unref(BULK_CREATE).locationStep,
                        onFormActivity: _unref(refreshAfterFormActivity)
                      }, null, 8, ["form-id", "label", "location-step", "onFormActivity"]),
                      _createVNode(_unref(ColumnVisibilityMenu), {
                        options: _unref(columnToggleOptions),
                        label: _ctx.$t('views.pigs.transfers.table.columnsButton'),
                        onToggle: _unref(toggleColumn),
                        onSelectAll: _cache[1] || (_cache[1] = ($event: any) => (_unref(setAllColumns)(true))),
                        onDeselectAll: _cache[2] || (_cache[2] = ($event: any) => (_unref(setAllColumns)(false)))
                      }, null, 8, ["options", "label", "onToggle"])
                    ])
                  ]),
                  _: 1
                }, 8, ["sorting", "column-filters", "columns", "rows", "totals", "facet-options", "loading", "heading", "subtitle", "onFormActivity"])
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }, 8, ["heading"]))
}
}

})